/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MarketRegisterScannerIcon20Solid = forwardRef('MarketRegisterScannerIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.5 2a3.5 3.5 0 0 0 0 7h8.191a2 2 0 0 0 1.901-1.38l1.194-3.654A1.5 1.5 0 0 0 16.36 2H6.5Z" }),
        React.createElement("path", { d: "M3.528 16.098 5.27 9.83c.391.11.804.17 1.231.17h3.579l-1.917 6.9A1.5 1.5 0 0 1 6.717 18H4.974a1.5 1.5 0 0 1-1.446-1.901Z" }),
        React.createElement("path", { d: "M9.99 13.428 10.976 10h2.409l-.68 2.178a1.781 1.781 0 0 1-1.7 1.25H9.99Z" })));
});
